export { EloMoney2Icon } from './money-2'
